// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SearchInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="16"
            height="15"
            fill="currentColor"
        >
            <path
                d="M646.268555,254.798828 L642.342774,250.873047 C643.192383,249.833008 643.661133,248.523437 643.661133,247.09375 C643.661133,243.727539 640.932715,241 637.567383,241 C634.202051,241 631.499994,243.728418 631.499994,247.09375 C631.499994,250.459082 634.228125,253.1875 637.567383,253.1875 C638.996778,253.1875 640.308107,252.69209 641.34668,251.867968 L645.272462,255.79375 C645.436524,255.932618 645.618164,256 645.796875,256 C645.975587,256 646.156641,255.931328 646.294043,255.794014 C646.567383,255.519531 646.567383,255.074219 646.268555,254.798828 L646.268555,254.798828 Z M632.90625,247.09375 C632.90625,244.50918 635.00918,242.40625 637.59375,242.40625 C640.178321,242.40625 642.28125,244.50918 642.28125,247.09375 C642.28125,249.67832 640.178321,251.78125 637.59375,251.78125 C635.00918,251.78125 632.90625,249.677735 632.90625,247.09375 Z"
                transform="translate(-631 -241)"
            />
        </svg>
    );
};

export default React.memo(SearchInactive);
